import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Tile,
  TileContent,
  TileGroup,
  TileMedia,
  TileText
} from '@one-thd/sui-atomic-components';
import { ConfirmedFilled } from '@one-thd/sui-icons';

const VisualRefinement = ({ dimension, onChange, refinements, dimensionId }) => {
  const [selectedTiles, setSelectedTiles] = useState([]);

  const updateSelectedTiles = (_event, selected) => {
    setSelectedTiles(selected);
  };

  const handleTileSelection = (_event, selected) => {
    if (onChange) {
      onChange({ refinement: selected, dimension });
    }
  };

  const getProductImageUrl = (imgUrl) => {
    const PRODUCT_CATALOG_IMAGE_PATH = 'https://images.homedepot-static.com/productImages';
    const SIZE = '100';

    if (Number(imgUrl) === 1 || !imgUrl) {
      return `https://images.homedepot-static.com/catalog/productImages/No_Image_${SIZE}.jpg`;
    }

    const cleanedImgUrl = imgUrl.trim();
    return `${PRODUCT_CATALOG_IMAGE_PATH}/${cleanedImgUrl}/svn/${cleanedImgUrl}_${SIZE}.jpg`;
  };

  const isTileSelected = (refinement) => {
    return selectedTiles.find((selected) => selected === refinement);
  };

  return (
    <TileGroup
      value={selectedTiles}
      disableExclusive
      onChange={updateSelectedTiles}
      className="sui-grid sui-grid-cols-2 md:sui-grid-cols-3 sui-gap-3"
      key={dimensionId}
      data-instoredisplay="true"
      data-testid="visual-refinement-card"
    >
      {refinements.map((refinement) => {
        const { imgUrl, label, refinementKey } = refinement || {};

        return (
          <div key={refinementKey}>
            {/* SEO-friendly hidden link - Required for SEO significance. Reach out to SEO team if wanting to change */}
            <a
              href={refinement.url}
              className="sui-hidden"
              aria-hidden="true"
              tabIndex="-1"
            >
              {/* H3 element required for SEO significance. Reach out to SEO team if wanting to change */}
              <h3>{label}</h3>
            </a>
            <Tile
              value={refinement}
              onClick={handleTileSelection}
              style={{ maxWidth: '136px' }}
            >
              <TileContent orientation="vertical" alignItems="start">
                <TileMedia src={getProductImageUrl(imgUrl)} />
                <TileText align="left">{label}</TileText>

                <div className="sui-h-2">
                  {isTileSelected(refinement) && (
                    <span className="sui-absolute sui-right-0 sui-bottom-0 sui-mr-2">
                      <ConfirmedFilled size="small" />
                    </span>
                  )}
                </div>

              </TileContent>
            </Tile>
          </div>
        );
      })}
    </TileGroup>
  );
};

VisualRefinement.propTypes = {
  dimension: PropTypes.shape({}),
  refinements: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      refinementKey: PropTypes.string,
      selected: PropTypes.bool,
      url: PropTypes.string,
      id: PropTypes.string,
      imgUrl: PropTypes.string
    })
  ),
  onChange: PropTypes.func.isRequired,
  dimensionId: PropTypes.string
};

VisualRefinement.defaultProps = {
  dimension: null,
  refinements: [],
  dimensionId: ''
};

VisualRefinement.displayName = 'VisualRefinement';

export { VisualRefinement };
